<section-header
    sectionTitle="Academic Program Review"
    navPath="/review"
    titleLink="/review/home"
    containerClass="container"
    [navLinks]="navLinks"></section-header>

<div class="pt-3">
    <router-outlet></router-outlet>
</div>
